// src/pages/admin/UserManagementHub.jsx
//
// User Management hub
// ===================
//
// This screen groups user-related administration areas. It intentionally stays
// as a routing hub: it does not load users, leave balances or leave types by
// itself. Keeping the hub passive prevents it from becoming another source of
// duplicated HR/business logic.
//
// i18n note:
// - Translate only visible labels, chips and descriptions.
// - Keep route paths unchanged because they are frontend routing contracts.

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./AdminSubPages.css";

export default function UserManagementHub() {
  const navigate = useNavigate();
  const { t } = useTranslation(["admin"]);

  return (
    <div className="admin-subpage">
      <div className="admin-subpage-inner">
        <div className="admin-sub-header">
          <div className="admin-sub-title">
            <h1>{t("admin:userManagementHub.title")}</h1>
            <p>{t("admin:userManagementHub.subtitle")}</p>
          </div>

          <button className="admin-sub-back-btn" onClick={() => navigate("/admin-panel")}>
            {t("admin:common.backWithArrow")}
          </button>
        </div>

        <div className="admin-sub-card">
          <div className="admin-sub-options">
            <div className="admin-sub-option">
              <button className="admin-sub-option-btn" onClick={() => navigate("/admin/master-data/leave-types")}>
                <div className="admin-sub-option-title">
                  <span>{t("admin:userManagementHub.tiles.masterData.title")}</span>
                  <span className="admin-sub-chip">
                    {t("admin:userManagementHub.tiles.masterData.chip")}
                  </span>
                </div>
                <div className="admin-sub-desc">
                  {t("admin:userManagementHub.tiles.masterData.description")}
                </div>
              </button>
            </div>

            <div className="admin-sub-option">
              <button className="admin-sub-option-btn" onClick={() => navigate("/users")}>
                <div className="admin-sub-option-title">
                  <span>{t("admin:userManagementHub.tiles.users.title")}</span>
                  <span className="admin-sub-chip">
                    {t("admin:userManagementHub.tiles.users.chip")}
                  </span>
                </div>
                <div className="admin-sub-desc">
                  {t("admin:userManagementHub.tiles.users.description")}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
